export var MaintenanceRunType;
(function (MaintenanceRunType) {
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_UNSPECIFIED"] = "MAINTENANCE_RUN_TYPE_UNSPECIFIED";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_COMPACTION"] = "COMPACTION";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_EXPIRE_SNAPSHOTS"] = "EXPIRE_SNAPSHOTS";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_REMOVE_ORPHAN_FILES"] = "REMOVE_ORPHAN_FILES";
})(MaintenanceRunType || (MaintenanceRunType = {}));
